export const normalizeColorSwatchKey = value =>
  `${value ?? ''}`
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

const DEFAULT_SWATCH = {
  background: 'linear-gradient(135deg, #e5e7eb 0%, #cbd5e1 100%)',
  borderColor: '#cbd5e1',
};

const SWATCH_ALIASES = {
  grey: 'gray',
  skintones: 'skin-tones',
  'skin-tone': 'skin-tones',
  'skin-tones': 'skin-tones',
  'skin-tones-and-browns': 'skin-tones',
  'multi-color': 'multi-colored',
  'multi-colord': 'multi-colored',
  'multi-colored': 'multi-colored',
  'multi-colour': 'multi-colored',
  'multi-coloured': 'multi-colored',
  multicolor: 'multi-colored',
  multicolored: 'multi-colored',
  pattern: 'print',
  turquoise: 'turquoise',
  turqoise: 'turquoise',
  'ballet-pink': 'pink',
  'classical-pink': 'pink',
  'theatrical-pink': 'pink',
};

const COLOR_SWATCHES = {
  black: {
    background: '#111111',
    borderColor: '#111111',
  },
  blue: {
    background: '#2563eb',
    borderColor: '#2563eb',
  },
  beige: {
    background: '#e6d5b8',
    borderColor: '#d7c5a7',
  },
  bronze: {
    background: '#b7793e',
    borderColor: '#b7793e',
  },
  brown: {
    background: '#7a4a28',
    borderColor: '#7a4a28',
  },
  burgundy: {
    background: '#800020',
    borderColor: '#800020',
  },
  clear: {
    background: 'linear-gradient(135deg, rgba(255,255,255,0.98) 0%, rgba(226,232,240,0.75) 100%)',
    borderColor: '#cbd5e1',
  },
  coral: {
    background: '#ff7f50',
    borderColor: '#ff7f50',
  },
  cream: {
    background: '#fff5d6',
    borderColor: '#eadcbc',
  },
  floral: {
    background: 'linear-gradient(135deg, #f9c5d1 0%, #fce38a 48%, #a8e6cf 100%)',
    borderColor: '#e4b7c3',
  },
  gold: {
    background: 'linear-gradient(135deg, #7c5a10 0%, #f0d27a 45%, #b48811 100%)',
    borderColor: '#c7a238',
  },
  gray: {
    background: '#808080',
    borderColor: '#808080',
  },
  green: {
    background: '#5ab63b',
    borderColor: '#5ab63b',
  },
  mint: {
    background: '#98f5c0',
    borderColor: '#82ddb0',
  },
  'multi-colored': {
    background:
      'conic-gradient(from 180deg, #ff4d4d, #ffb347, #ffe066, #65d672, #38bdf8, #6366f1, #c084fc, #ff4d4d)',
    borderColor: '#cbd5e1',
  },
  nude: {
    background: '#e3bc9a',
    borderColor: '#d2aa87',
  },
  orange: {
    background: '#f7931e',
    borderColor: '#f7931e',
  },
  peach: {
    background: '#ffc4a3',
    borderColor: '#e6ab89',
  },
  periwinkle: {
    background: '#c3c8ff',
    borderColor: '#aab0f6',
  },
  pink: {
    background: '#d678a8',
    borderColor: '#d678a8',
  },
  print: {
    background:
      'repeating-linear-gradient(135deg, #111827 0 6px, #f8fafc 6px 12px, #fb923c 12px 18px, #14b8a6 18px 24px)',
    borderColor: '#94a3b8',
  },
  purple: {
    background: '#9333ea',
    borderColor: '#9333ea',
  },
  red: {
    background: '#d32f2f',
    borderColor: '#d32f2f',
  },
  sand: {
    background: '#d6c29c',
    borderColor: '#c6b28c',
  },
  silver: {
    background: 'linear-gradient(135deg, #f5f5f5 0%, #aeb4ba 55%, #ffffff 100%)',
    borderColor: '#b8bfc6',
  },
  'skin-tones': {
    background: 'linear-gradient(135deg, #f3d0b3 0%, #dca984 50%, #b37c58 100%)',
    borderColor: '#d3a280',
  },
  tan: {
    background: '#d2b48c',
    borderColor: '#c49f73',
  },
  teal: {
    background: '#0f766e',
    borderColor: '#0f766e',
  },
  turquoise: {
    background: '#40e0d0',
    borderColor: '#40e0d0',
  },
  white: {
    background: '#f8fafc',
    borderColor: '#d1d5db',
  },
  yellow: {
    background: '#fff36b',
    borderColor: '#eadc5e',
  },
};

export const resolveColorSwatch = value => {
  const normalizedKey = normalizeColorSwatchKey(value);

  if (!normalizedKey) {
    return DEFAULT_SWATCH;
  }

  const canonicalKey = SWATCH_ALIASES[normalizedKey] || normalizedKey;

  return COLOR_SWATCHES[canonicalKey] || DEFAULT_SWATCH;
};
